import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="opportunities" />;
}

export const Route = createFileRoute('/crm/opportunities')({
  component: withPermission(Preview, { key: crmNavItem('opportunities').access, route: AclRoute.CRM, resourceLabel: 'Opportunities' }),
});
